import type { InputHTMLAttributes } from "react";

type FieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string;
};

export function Field({ label, hint, className = "", ...props }: FieldProps) {
  return (
    <label className="grid gap-2 text-sm text-text">
      <span className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-muted">{label}</span>
      <input
        className={`min-h-12 rounded-token border border-border/70 bg-elevated px-3 py-2.5 text-base font-medium text-text transition placeholder:text-muted/80 focus:border-primary focus:bg-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus/20 ${className}`}
        {...props}
      />
      {hint ? <span className="text-xs font-medium leading-5 text-muted">{hint}</span> : null}
    </label>
  );
}
